import React from "react";
import { useTranslation } from "react-i18next";

const MetroMinutoPopup = ({ onAccept, onDecline }) => {
  const { t } = useTranslation();

  return (
    <>
      <style>
        {`
          .popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.3);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
          }
          .popup-card {
            background-color: #09BAC4;
            color: #333;
            padding: 30px;
            border-radius: 8px;
            text-align: center;
            max-width: 400px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
          .popup-title {
            color: #FFD437;
            margin-bottom: 15px;
            font-size: 20px;
            font-weight: bold;
          }
          .popup-text {
            font-size: 16px;
            margin-bottom: 20px;
          }
          .popup-button-container {
            display: flex;
            justify-content: center;
            gap: 15px;
          }
          .popup-button {
            padding: 10px 15px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-size: 14px;
            font-weight: bold;
            transition: 0.3s ease;
          }
          .accept-button {
            background-color: #28a745;
            color: white;
          }
          .accept-button:hover {
            background-color: #218838;
          }
          .decline-button {
            background-color: #dc3545;
            color: white;
          }
          .decline-button:hover {
            background-color: #c82333;
          }
        `}
      </style>
      <div className="popup-overlay">
        <div className="popup-card">
          <h2 className="popup-title">
            {t("mayatrackpopup.titulo")}
          </h2>
          <p className="popup-text">
            <span
              dangerouslySetInnerHTML={{
                __html: t("mayatrackpopup.subtitulo"),
              }}
            />
            <br />
            <br />
            <span
              dangerouslySetInnerHTML={{
                __html: t("mayatrackpopup.subtitulo2"),
              }}
            />
            <br />
            <br />
            <span
              style={{ color: "#dc3545", fontWeight: "bold" }}
              dangerouslySetInnerHTML={{
                __html: t("mayatrackpopup.subtitulo3"),
              }}
            />
          </p>
          <div className="popup-button-container">
            <button
              className="popup-button accept-button"
              onClick={onAccept}
            >
              {t("mayatrackpopup.botonaceptar")}
            </button>
            <button
              className="popup-button decline-button"
              onClick={onDecline}
            >
              {t("mayatrackpopup.botoncerrar")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetroMinutoPopup;
